import { IconName } from "@telia/teddy";

export const getSocialMediaIconFromName = (name: string | null): IconName => {
    if (!name) {
        return "telia-logo";
    }

    switch (name.toLowerCase()) {
        case "facebook":
            return "facebook";
        case "youtube":
            return "youtube";
        case "instagram":
            return "instagram";
        default:
            return "telia-logo";
    }
};
